import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { TrendingUp } from "lucide-react";

interface NavData {
  navPerShare?: number | string;
  currency?: string;
  calculationDate?: string;
}

interface NavCardProps {
  navData: number | NavData | null;
}

export const NavCard: React.FC<NavCardProps> = ({ navData }) => {
  return (
    <Card className="overflow-hidden">
      <CardHeader className="bg-muted/50 pb-4">
        <CardTitle className="flex items-center gap-2 text-lg">
          <TrendingUp className="h-5 w-5 text-green-500" />
          Net Asset Value
        </CardTitle>
        <CardDescription>
          Fund NAV for the reporting period
        </CardDescription>
      </CardHeader>
      <CardContent className="pt-6">
        {navData ? (
          <div className="space-y-2">
            <div className="flex flex-col">
              <span className="text-3xl font-bold">
                {typeof navData === 'number' 
                  ? navData.toLocaleString('en-US', {
                      style: 'currency',
                      currency: 'USD'
                    })
                  : 'N/A'
                }
              </span>
              <span className="text-sm text-muted-foreground">
                Total NAV
              </span>
            </div>
            {typeof navData === 'object' && navData.navPerShare && (
              <div className="pt-2 border-t">
                <div className="flex justify-between text-sm">
                  <span>NAV per Share</span>
                  <span className="font-medium">
                    {navData.currency || 'USD'} {' '}
                    {typeof navData.navPerShare === 'number'
                      ? navData.navPerShare.toLocaleString(undefined, {
                          minimumFractionDigits: 4,
                          maximumFractionDigits: 4,
                        })
                      : navData.navPerShare
                    }
                  </span>
                </div>
              </div>
            )}
            {typeof navData === 'object' && navData.calculationDate && (
              <div className="pt-1">
                <span className="text-xs text-muted-foreground">
                  As of {new Date(navData.calculationDate).toLocaleDateString()}
                </span>
              </div>
            )}
          </div>
        ) : (
          <div className="flex flex-col items-center gap-2">
            <span className="text-2xl font-bold text-muted-foreground">
              No Data
            </span>
            <span className="text-sm text-muted-foreground">
              NAV data not available
            </span>
          </div>
        )}
      </CardContent>
    </Card>
  );
}; 